import Alpine from 'alpinejs';
import Upload from 'adeliom-upload-js';

export const defaultUploadFileSettings = {
    maxFileSize: 4,
    maxTotalFilesSize: 8,
    maxNbFiles: 2,
    fileExtensions: [".jpg", ".jpeg", ".png", ".pdf", ".exe"],
    customContentOnly: false,
    displayMaxFileSize: false,
    displayRestSize: false,
    displayRestFiles: false,
    dropZone: true,
    language: 'fr',
    languages: {
        fr: {
            textBtnUpload: 'Ajouter des photos',
            textBeforeUpload: 'Aucun fichier sélectionné',
            textAfterUpload: 'Vos fichiers',
            textSizeRest: '{{number}} restant',
            textFileRest: '{{number}} fichier{{s}} restant{{s}}',
            textMaxFileSize: '{{number}} maximum par fichier',
            textFileNotValid: "Votre fichier n'est pas valide:",
            textMultipleFileNotValid: "Vos fichiers ne sont pas valides:",
            textFileTooBig: "Merci d'utiliser des fichiers moins lourds ou de nous envoyer les pièces complémentaires lors de nos échanges à venir :",
            textMultipleFileTooBig: "Merci d'utiliser des fichiers moins lourds ou de nous envoyer les pièces complémentaires lors de nos échanges à venir :",
            textTotalFilesSize: "Merci d'utiliser un fichier moins lourds ou de nous envoyer les pièces complémentaires lors de nos échanges à venir",
            textTooManyFiles: "Merci d'envoyer jusqu'à 2 fichiers maximum. N'hésitez pas à nous envoyer les pièces complémentaires lors de nos échanges à venir",
            textTotalFiles: "La limite du nombre de fichier est atteinte",
            textErrorsUpload: "Une erreur est survenue, impossible de télécharger le fichier."
        }
    },
    useBase64Inputs: true,
}

document.addEventListener('alpine:init', () => {
  Alpine.data('initInputFileClassicForm', () => {
    return {
      init() {
          const field = document.getElementById( this.$refs.inputFile.id);
          let extensions:string[] = defaultUploadFileSettings.fileExtensions;

          if(field && field.hasAttribute('accept')){
              const accept = field.getAttribute('accept');

              if(accept){
                   extensions = accept.split(',');
              }
          }

        const uploadField = new Upload({
            ...defaultUploadFileSettings,
            ...{
                selector: '#' + this.$refs.inputFile.id,
                fileExtensions: extensions
            }
        });
        uploadField.init();

      }
    }
  })
})
